"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../shared/components/table_actions/TableActionDelete");
var TableActionEdit_1 = require("../../../../../../shared/components/table_actions/TableActionEdit");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ToolBarBrandFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarBrandFilter");
var TableMenuIsLocked_1 = require("../../../../../../shared/components/table_menus/TableMenuIsLocked");
var TableActionConfig_1 = require("../../../../../../shared/components/table_actions/TableActionConfig");
var FontAwesome_1 = require("../../../../../../shared/components/icons/FontAwesome");
var DropDownButtonReFresh_1 = require("../../../../../../shared/components/dropdown_buttons/DropDownButtonReFresh");
var TableActionFlag_1 = require("../../../../../../shared/components/table_actions/TableActionFlag");
var TableActionDollar_1 = require("../../../../../../shared/components/table_actions/TableActionDollar");
var ButtonThunderBolt_1 = require("../../../../../../shared/components/buttons/ButtonThunderBolt");
var GameSetsList = /** @class */ (function (_super) {
    __extends(GameSetsList, _super);
    function GameSetsList(props) {
        var _this = _super.call(this, props) || this;
        _this.searchDescriptionInput = null;
        _this.searchTitleInput = null;
        return _this;
    }
    GameSetsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
            searchDescriptionFilter: [],
            searchDescriptionValue: "",
            searchTitleFilter: [],
            searchTitleValue: "",
            loadOrder: "byKey"
        }, function () {
            _this.props.data.LoadData(_this.props.allGwsGameProviders, _this.state.loadOrder, _this.props.gwsGameProvidersList);
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    GameSetsList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    GameSetsList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize
            }, function () {
                nextProps.data.LoadData(_this.props.allGwsGameProviders, _this.state.loadOrder, _this.props.gwsGameProvidersList);
            });
        }
    };
    GameSetsList.prototype.doLockUnLockAction = function (Key, Title, Lock) {
        this.props.data.SetIsLocked(Key, Lock, function () {
            if (Lock) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041D\u0430\u0431\u043E\u0440 \u0438\u0433\u0440 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041D\u0430\u0431\u043E\u0440 \u0438\u0433\u0440 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0440\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
        });
    };
    GameSetsList.prototype.getCategoryLevelsArray = function () {
        var _ret = [];
        for (var i = 1; i <= 30; i++) {
            _ret.push(React.createElement(antd_1.Menu.Divider, { key: "" + i }));
            _ret.push(React.createElement(antd_1.Menu.Item, { key: "" + i },
                React.createElement(FontAwesome_1.FA, { icon: "level-down-alt", left: true }),
                "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u043D\u043E\u043C\u0435\u0440 ",
                i,
                " "));
        }
        return _ret;
    };
    GameSetsList.prototype.getMenuLevelsArray = function () {
        var _ret = [];
        for (var i = 1; i <= 30; i++) {
            _ret.push(React.createElement(antd_1.Menu.Divider, { key: "" + i }));
            _ret.push(React.createElement(antd_1.Menu.Item, { key: "" + i },
                React.createElement(FontAwesome_1.FA, { icon: "level-down-alt", left: true }),
                "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u043D\u043E\u043C\u0435\u0440 ",
                i,
                " "));
        }
        return _ret;
    };
    GameSetsList.prototype.getMoreCategoryActionsDropDownMenu = function (record) {
        var _this = this;
        return (React.createElement(antd_1.Menu, { onClick: function (e) { _this.doSetPriorityCategoryAction(e, record); } }, this.getCategoryLevelsArray()));
    };
    GameSetsList.prototype.doSetPriorityCategoryAction = function (e, record) {
        var _this = this;
        var _level = 1;
        _level = parseInt(e.key, 10);
        this.props.data.doSetSortOrderCategory(record.key, _level, function () {
            _this.props.data.LoadData(_this.props.allGwsGameProviders, _this.state.loadOrder, _this.props.gwsGameProvidersList, function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041F\u043E\u0440\u044F\u0434\u043A\u043E\u0432\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u0432 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438 \u0434\u043B\u044F \u043D\u0430\u0431\u043E\u0440\u0430 \u0438\u0433\u0440 ",
                    React.createElement("b", null, record.title),
                    " \u0438\u0437\u043C\u0435\u043D\u0435\u043D !"));
            });
        });
    };
    GameSetsList.prototype.getMoreMenuActionsDropDownMenu = function (record) {
        var _this = this;
        return (React.createElement(antd_1.Menu, { onClick: function (e) { _this.doSetPriorityMenuAction(e, record); } }, this.getMenuLevelsArray()));
    };
    GameSetsList.prototype.doSetPriorityMenuAction = function (e, record) {
        var _this = this;
        var _level = 1;
        _level = parseInt(e.key, 10);
        this.props.data.doSetSortOrderMenu(record.key, _level, function () {
            _this.props.data.LoadData(_this.props.allGwsGameProviders, _this.state.loadOrder, _this.props.gwsGameProvidersList, function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041F\u043E\u0440\u044F\u0434\u043A\u043E\u0432\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u0432 \u043C\u0435\u043D\u044E \u0434\u043B\u044F \u043D\u0430\u0431\u043E\u0440\u0430 \u0438\u0433\u0440 ",
                    React.createElement("b", null, record.title),
                    " \u0438\u0437\u043C\u0435\u043D\u0435\u043D !"));
            });
        });
    };
    GameSetsList.prototype.getAttributes = function (record) {
        var _ret = "";
        if (record.is_in_menu) {
            _ret = "M(" + record.init_gm_cnt_in_menu.toString() + ")";
        }
        if (record.is_in_category) {
            if (record.is_in_menu) {
                _ret += "\\";
            }
            _ret += "C(" + record.init_gm_cnt_in_category.toString() + ")";
        }
        if (record.is_in_main_mobile_menu) {
            if ((record.is_in_menu) || (record.is_in_category)) {
                _ret += "\\";
            }
            _ret += "MM";
        }
        if (_ret.length > 0) {
            _ret += "\\";
        }
        _ret += "F(" + record.fsconfig_count.toString() + ")";
        return _ret;
    };
    GameSetsList.prototype.onClearDescriptionFilter = function () {
        this.setState({ searchDescriptionFilter: [], searchDescriptionValue: "" });
    };
    GameSetsList.prototype.onChangeDescriptionFilter = function (e) {
        this.setState({ searchDescriptionValue: e.target.value });
    };
    GameSetsList.prototype.onConfirmDescriptionFilter = function () {
        this.setState({ searchDescriptionFilter: [this.state.searchDescriptionValue] });
    };
    GameSetsList.prototype.onClearTitleFilter = function () {
        this.setState({ searchTitleFilter: [], searchTitleValue: "" });
    };
    GameSetsList.prototype.onChangeTitleFilter = function (e) {
        this.setState({ searchTitleValue: e.target.value });
    };
    GameSetsList.prototype.onConfirmTitleFilter = function () {
        this.setState({ searchTitleFilter: [this.state.searchTitleValue] });
    };
    GameSetsList.prototype.getColumns = function () {
        var _this = this;
        var _description_filter = this.state.searchDescriptionFilter;
        var _title_filter = this.state.searchTitleFilter;
        return [{
                title: 'Название',
                dataIndex: this.props.data.dk_title,
                key: this.props.data.dk_title,
                width: 200,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchTitleInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044E", value: _this.state.searchTitleValue, onChange: _this.onChangeTitleFilter.bind(_this), onPressEnter: function () { _this.onConfirmTitleFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmTitleFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearTitleFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _title_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.title.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchTitleInput.focus();
                        });
                    }
                }
            }, {
                title: 'Тип группы',
                dataIndex: this.props.data.dk_cms_gameset_category_type_title,
                key: this.props.data.dk_cms_gameset_category_type_title,
                align: "center",
                width: 150,
            }, {
                title: 'Тэг',
                dataIndex: this.props.data.dk_tag,
                key: this.props.data.dk_tag,
                align: "center",
                width: 150,
            }, {
                title: 'Геймпровайдер',
                dataIndex: this.props.data.dk_gws_gameprovider_title,
                key: this.props.data.dk_gws_gameprovider_title,
                align: "center",
                width: 200,
            }, {
                title: 'Кол-во игр',
                dataIndex: this.props.data.dk_games_count,
                key: this.props.data.dk_games_count,
                align: "center",
                width: 150,
            }, {
                title: 'Аттрибуты',
                dataIndex: this.props.data.dk_is_in_category,
                key: this.props.data.dk_is_in_category,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement("div", null, _this.getAttributes(record)));
                },
                width: 150,
            }, {
                title: '№ п/п в категории',
                dataIndex: this.props.data.dk_sort_order_category,
                key: this.props.data.dk_sort_order_category,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(antd_1.Dropdown, { overlay: _this.getMoreCategoryActionsDropDownMenu(record), trigger: ['click'], disabled: !record.is_in_category },
                        React.createElement(antd_1.Button, { style: { width: 120, minWidth: 120, maxWidth: 120 } },
                            "\u041D\u043E\u043C\u0435\u0440-",
                            record.sort_order_category,
                            " ",
                            React.createElement(antd_1.Icon, { type: "down" }))));
                },
                width: 200,
            }, {
                title: '№ п/п в меню',
                dataIndex: this.props.data.dk_sort_order_menu,
                key: this.props.data.dk_sort_order_menu,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(antd_1.Dropdown, { overlay: _this.getMoreMenuActionsDropDownMenu(record), trigger: ['click'], disabled: !record.is_in_menu },
                        React.createElement(antd_1.Button, { style: { width: 120, minWidth: 120, maxWidth: 120 } },
                            "\u041D\u043E\u043C\u0435\u0440-",
                            record.sort_order_menu,
                            " ",
                            React.createElement(antd_1.Icon, { type: "down" }))));
                },
                width: 200,
            }, {
                title: 'Заблокирован',
                dataIndex: this.props.data.dk_is_locked,
                key: this.props.data.dk_is_locked,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsLocked_1.default, { lockedTexts: { menu: "Заблокировать", text: "Да" }, unlockedTexts: { menu: "Разблокировать", text: "Нет" }, record: { key: record.key, title: record.title, locked: record.is_locked }, onLockClick: _this.doLockUnLockAction.bind(_this) }));
                },
                width: 150,
            }, {
                title: 'Комментарий',
                dataIndex: this.props.data.dk_description,
                key: this.props.data.dk_description,
                width: 200,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchDescriptionInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u044E", value: _this.state.searchDescriptionValue, onChange: _this.onChangeDescriptionFilter.bind(_this), onPressEnter: function () { _this.onConfirmDescriptionFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmDescriptionFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearDescriptionFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _description_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.description.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchDescriptionInput.focus();
                        });
                    }
                }
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditGameSetClick(record); } }),
                    React.createElement(TableActionConfig_1.default, { hint: "\u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C", onClick: function () { _this.onConfigGameSetClick(record); } }),
                    React.createElement(TableActionFlag_1.default, { hint: "\u041B\u043E\u043A\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438", onClick: function () { _this.onTranslateGameSetClick(record); } }),
                    React.createElement(TableActionDollar_1.default, { hint: "\u0421\u0442\u0430\u0432\u043A\u0438 \u043F\u043E \u0424\u0421.", onClick: function () { _this.onFSBetGameSetClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }))); },
                width: 150
            }];
    };
    GameSetsList.prototype.onTranslateGameSetClick = function (record) {
        if (this.props.onTranslateClick) {
            this.props.onTranslateClick(record);
        }
    };
    GameSetsList.prototype.onFSBetGameSetClick = function (record) {
        if (this.props.onFSBetClick) {
            this.props.onFSBetClick(record);
        }
    };
    GameSetsList.prototype.onEditGameSetClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    GameSetsList.prototype.onConfigGameSetClick = function (record) {
        if (this.props.onConfigClick) {
            this.props.onConfigClick(record);
        }
    };
    GameSetsList.prototype.onDeleteClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u0413\u0440\u0443\u043F\u043F\u0430 \u0438\u0433\u0440 ",
                React.createElement("b", null,
                    "[",
                    record.title,
                    "]"),
                " \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u0430"));
        });
    };
    GameSetsList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        var _PageSize = this.state.pageSize;
        if (PageSize) {
            _PageSize = PageSize;
        }
        this.setState({ pageNum: _page, pageSize: _PageSize }, function () {
            _this.props.data.LoadData(_this.props.allGwsGameProviders, _this.state.loadOrder, _this.props.gwsGameProvidersList, function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, _PageSize);
                }
            });
        });
    };
    GameSetsList.prototype.onToolBarClick = function (action) {
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
    };
    GameSetsList.prototype.doLoadData = function (key) {
        var _this = this;
        if (key === 0) {
            this.setState({ loadOrder: "byKey" }, function () {
                _this.props.data.LoadData(_this.props.allGwsGameProviders, _this.state.loadOrder, _this.props.gwsGameProvidersList);
            });
        }
        if (key === 1) {
            this.setState({ loadOrder: "byCategory" }, function () {
                _this.props.data.LoadData(_this.props.allGwsGameProviders, _this.state.loadOrder, _this.props.gwsGameProvidersList);
            });
        }
        if (key === 2) {
            this.setState({ loadOrder: "byMenu" }, function () {
                _this.props.data.LoadData(_this.props.allGwsGameProviders, _this.state.loadOrder, _this.props.gwsGameProvidersList);
            });
        }
    };
    GameSetsList.prototype.OnGwsGameProviderFilterChanged = function (allBrands, BrandId, Action) {
        if (this.props.onGwsGameProviderFilterChanged) {
            this.props.onGwsGameProviderFilterChanged(allBrands, BrandId, Action);
        }
    };
    GameSetsList.prototype.doAddGameToGameSets = function () {
        var _this = this;
        this.props.dlgAddGame.SetDialogTitle("Опубликовать игру").SetOnYesClick(function (gameproviderId, gameId, currencyId, isTableGame, addToTop, topLevel) {
            _this.props.data.doAddGameToAllGameSets({
                gameprovider_game_id: gameId,
                is_table_game: isTableGame,
                is_add_to_top: addToTop,
                offset_from_top_place_down: topLevel,
                app_currency_id: currencyId
            }, function (gameTitle) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0418\u0433\u0440\u0430 ",
                    React.createElement("b", null,
                        "[",
                        gameTitle,
                        "]"),
                    " \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u043D\u0430"));
            });
        }).SetOnNoClick(function () { _this.props.dlgAddGame.Close(); }).Show();
    };
    GameSetsList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(ButtonThunderBolt_1.default, { hint: "Опубликовать новую игру", onClick: function () { _this.doAddGameToGameSets(); } }),
                React.createElement(DropDownButtonReFresh_1.default, { hint: "Загрузить", onItemClick: this.doLoadData.bind(this), title: "Загрузить", items: [
                        { key: 0, value: "Загрузить все", icon: "sync", separatorAfter: true },
                        { key: 1, value: "Загрузить категории", icon: "sync" },
                        { key: 2, value: "Загрузить меню", icon: "sync" }
                    ] }),
                React.createElement(ToolBarBrandFilter_1.default, { allBrands: this.props.allGwsGameProviders, availBrands: this.props.availGwsGameProviders, captions: { checkbox: "Все геймпровайдеры", placeholder: "Выберите геймпровайдера" }, selectedBrands: this.props.gwsGameProvidersList, onBrandFilterChanged: this.OnGwsGameProviderFilterChanged.bind(this) })),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.getColumns(), dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added2.format(_this.props.state.getDateTimeFormat()),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                            " [",
                            record.date_changed2.format(_this.props.state.getDateTimeFormat()),
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0439 CSS \u043A\u043B\u0430\u0441\u0441:"),
                            " [",
                            record.css_inactive_classname,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0410\u043A\u0442\u0438\u0432\u043D\u044B\u0439 CSS \u043A\u043B\u0430\u0441\u0441:"),
                            " [",
                            record.css_active_classname,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u044F\u0437\u044B\u043A\u043E\u0432:"),
                            " [",
                            record.langs_count,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435:"),
                            " [",
                            record.description,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430:"),
                            " [",
                            record.gameprovider_value,
                            "]")));
                }, scroll: { x: true } })));
    };
    return GameSetsList;
}(React.Component));
exports.default = GameSetsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_gamesets_list/ui/component/GameSetsList.tsx
// module id = 1994
// module chunks = 0